import React, { Component, PropTypes } from 'react';
import FullScreenDialog from 'components/FullScreenDialog';
import PoweredBy from 'Cio/Assets/PoweredBy';
import { Units } from 'Css';
import { RaisedButton } from 'material-ui';

const css = oxygenCss({
  root: {
    position: 'relative'
  },
  logo: {
    borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: '#DDD',
    padding: Units.base * 2,
    lineHeight: '32px',
    color: '#09BEC3',
    fontSize: '24px',
    ' >SPAN': {
      verticalAlign: 'middle',
      marginLeft: '8px'
    }
  },
  container: {
    padding: Units.base * 4
  },
  buttonContainer: {
    paddingTop: Units.base * 4
  }
});

class AlertDialog extends Component {
  static propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool,
    onRequestClose: PropTypes.func,
    title: PropTypes.node
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    const { children, open, title, onRequestClose } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <FullScreenDialog
        open={open}
        toolbar={false}
        onRequestClose={onRequestClose}
      >
        <div className={css.container}>
          {title && <h1>{title}</h1>}
          {children}
          <div className={css.buttonContainer}>
            <RaisedButton
              fullWidth
              secondary
              label={getIntlMessage('OK')}
              onTouchTap={onRequestClose}
            />
          </div>
        </div>
        <div className={css.details}>
          <h4 className={css.logo}>
            <PoweredBy color={'#09BEC3'} borderColor={'#09BEC3'} />
          </h4>
        </div>
      </FullScreenDialog>
    );
  }
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/js/components/AlertDialog.js